import React from 'react'

function Ntse() {
  return (
    <div>Ntse</div>
  )
}

export default Ntse